<template>
  <div class="l-content">
    <div class="video row">
      <div class="video-container-outer col-xs-16 col-xs-offset-1 col-sm-16 col-sm-offset-1 col-md-12 col-md-offset-4">
        <a @click="playVideo" :class="{isVideoReady}">

          <img v-if="preview" :src="preview" class="video-thumbnail img-responsive" alt="" @click="playVideo">
          <!-- maxresdefault -->
          <img v-else :src="`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`" class="video-thumbnail img-responsive" alt="" @click="playVideo">
          <div class="play-button" v-if="isVideoReady">
            <PlayButton />
          </div>
        </a>
      </div>
      <div class="video-copy">
        <p class="t-chartbody t-green-light" v-html="title"></p>
        <div class="t-hr"></div>
        <p class="t-darker-grey" v-html="description"></p>
      </div>

      <transition name="video-modal">
        <div class="video-modal-mask" v-show="showModal" @click="closeModal">
          <div class="video-modal-wrapper">
            <div class="video-modal-container">
              <youtube @ready="onYoutubeReady" class="video-container-inner" :video-id="videoId" :playerVars="{controls: 1, modestbranding: 1}" ref="youtube" />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import PlayButton from '@/assets/play.svg'

export default {
  name: 'YouTubeVideo',
  components: {
    PlayButton
  },
  props: {
    videoId: {
      type: String,
      required: false,
      default: 'y2Ky3Wo37AY'
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    preview: {
      type: String,
      required: false
    }
  },
  data: () => ({
    played: false,
    showModal: false,
    isVideoReady: false
  }),
  methods: {
    onYoutubeReady (player) {
      this.player = player
      this.isVideoReady = true
    },
    playVideo () {
      this.played = true
      this.player.playVideo()
      this.showModal = true
      this.$root.modalOpen = true
    },
    stopVideo () {
      this.player.stopVideo()
    },
    closeModal () {
      this.stopVideo()
      this.showModal = false
      this.$root.modalOpen = false
    }
  }
}
</script>
<style lang="scss">
@import '../scss/vars';
@import '../scss/mixins';

.video {
  position: relative;
}
.video-copy {
  text-align: left;
  background: $white;
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(0,0,0,.05);
  padding: 28px;
  position: relative;
  left: 11.11%;
  top: -20px;
  width: 77.77%;
  p {
    margin-bottom: 0;
  }
  @media (min-width: 960px) {
    position: absolute;
    width: 22.22%;
    top: 40px;
    bottom: auto;
  }
  h3 {
    @include underbar();
    color: $green-light;
  }
}
.video-container-outer {
  position: relative;
  a {
    pointer-events: none; // Wait until video is ready
    &.isVideoReady {
      pointer-events: all;
      cursor: pointer;
    }
    &:hover {
      svg { fill: $green-light; }
    }
  }
}
.video-container-inner {
  position: relative;
  padding-bottom: 56.25%; /* 16:9. Still dialing this in */
  padding-top: 25px;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.video-thumbnail {
  // border-radius: 10px;
}
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95px;
  height: auto;
  cursor: pointer;
  svg {
    fill: $white;
  }
}

.video-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.8);
  display: table;
  transition: opacity .3s ease;

  .video-modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .video-modal-container {
    width: 80%;
    margin: auto;
    transition: all .3s ease;
  }
}

.video-modal-enter, .video-modal-leave-active {
  opacity: 0
}
.video-modal-enter .video-modal-container,
.video-modal-leave-active .video-modal-container {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/YouTubeVideo.vue